// extracted by mini-css-extract-plugin
module.exports = {"navBarMenuOpen":"TopNavigationTenantMenu_nav-bar-menu-open__NitOp","navBarTenant":"TopNavigationTenantMenu_nav-bar-tenant__3wCpG"};